import { render, staticRenderFns } from "./RoomBoardCard.vue?vue&type=template&id=1df01e52&scoped=true&"
import script from "./RoomBoardCard.vue?vue&type=script&lang=js&"
export * from "./RoomBoardCard.vue?vue&type=script&lang=js&"
import style0 from "./RoomBoardCard.vue?vue&type=style&index=0&id=1df01e52&lang=scss&scoped=true&"
import style1 from "./RoomBoardCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df01e52",
  null
  
)

export default component.exports